import {
  changeFieldValueAndUpdate,
  clearFieldsValue,
  clearHiddenDictionaryEntries,
  getCheckoutFormValues,
  getCheckoutOwnerData,
  getQuestionVisibility,
  getQuotation,
  setQuestionsVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  setLicenseMonthVisibility,
  setupLicenseDates,
} from 'app/services/businessFunctions.service';
import { setBirthdateAndGenderByPesel } from 'app/services/businessFunctions/helpers/setBirthdateAndGenderByPesel';
import { validateCheckoutPesel } from 'app/services/pesel.service/validateCheckoutPesel';
import { QuotationService } from 'app/services/quotation.service';
import {
  FieldsEnum,
  FormsEnum,
  ModelPathEnum,
  PersonType,
} from 'app/shared/enums';

const inexperiencedAdditionalDriverInitialQuestions = [
  FieldsEnum.InexperiencedAdditionalDriverBirthDate,
  FieldsEnum.InexperiencedAdditionalDriverLicenseYear,
];

const inexperiencedAdditionalDriverDetailsQuestions = [
  ...inexperiencedAdditionalDriverInitialQuestions,
  FieldsEnum.InexperiencedAdditionalDriverLicenseMonth,
];

const hasInexperiencedAdditionalDriverDetails = () => {
  const { inexperiencedAdditionalDriver } = getQuotation();

  return Object.values(inexperiencedAdditionalDriver ?? {}).some(Boolean);
};

const ownerDetails = {
  checkoutOwnerPeselChange() {
    const { peselCheckoutForm: pesel } = getCheckoutOwnerData();
    const isPeselCorrect = validateCheckoutPesel(PersonType.Owner);

    if (!isPeselCorrect) {
      return;
    }

    const { id } = getQuotation();
    QuotationService.update(id, ModelPathEnum.MainOwnerPeselNumber, pesel);

    setBirthdateAndGenderByPesel(
      false,
      parseInt(pesel),
      FormsEnum.CheckoutForm,
      FieldsEnum.OwnerBirthDate,
      FieldsEnum.OwnerGender
    );
  },
  hasInexperiencedAdditionalDriverChange() {
    const isQuestionVisible = getQuestionVisibility(
      FieldsEnum.HasInexperiencedAdditionalDriver,
      FormsEnum.CheckoutForm
    );
    const { hasInexperiencedAdditionalDriver } = getCheckoutFormValues();
    const shouldShowDetails =
      Boolean(isQuestionVisible) && Boolean(hasInexperiencedAdditionalDriver);

    if (shouldShowDetails) {
      setQuestionsVisibility(
        inexperiencedAdditionalDriverInitialQuestions,
        true,
        FormsEnum.CheckoutForm
      );
      ownerDetails.setupInexperiencedAdditionalDriverLicenseDates();
      return;
    }

    setQuestionsVisibility(
      inexperiencedAdditionalDriverDetailsQuestions,
      false,
      FormsEnum.CheckoutForm
    );
    clearHiddenDictionaryEntries({
      dictionaryKey: `months_${FieldsEnum.InexperiencedAdditionalDriverLicenseMonth}`,
      formName: FormsEnum.CheckoutForm,
    });

    if (hasInexperiencedAdditionalDriverDetails()) {
      clearFieldsValue(
        inexperiencedAdditionalDriverDetailsQuestions,
        FormsEnum.CheckoutForm
      );
    }

    if (!isQuestionVisible && hasInexperiencedAdditionalDriver) {
      changeFieldValueAndUpdate(
        FieldsEnum.HasInexperiencedAdditionalDriver,
        false,
        FormsEnum.CheckoutForm
      );
    }
  },
  setupInexperiencedAdditionalDriverLicenseDates() {
    const isBirthDateQuestionVisible = getQuestionVisibility(
      FieldsEnum.InexperiencedAdditionalDriverBirthDate,
      FormsEnum.CheckoutForm
    );

    if (!isBirthDateQuestionVisible) return;

    setupLicenseDates(
      FieldsEnum.InexperiencedAdditionalDriverLicenseMonth,
      FieldsEnum.InexperiencedAdditionalDriverLicenseYear,
      FieldsEnum.InexperiencedAdditionalDriverBirthDate,
      undefined,
      FormsEnum.CheckoutForm,
      true
    );
  },
  setInexperiencedAdditionalDriverLicenseMonthVisibility() {
    const isLicenseYearQuestionVisible = getQuestionVisibility(
      FieldsEnum.InexperiencedAdditionalDriverLicenseYear,
      FormsEnum.CheckoutForm
    );

    if (!isLicenseYearQuestionVisible) return;

    setLicenseMonthVisibility(
      FieldsEnum.InexperiencedAdditionalDriverBirthDate,
      FieldsEnum.InexperiencedAdditionalDriverLicenseYear,
      FieldsEnum.InexperiencedAdditionalDriverLicenseMonth,
      undefined,
      FormsEnum.CheckoutForm,
      true
    );
  },
};

export default ownerDetails;
